import React from 'react';
import adminlogo from '../assets/images/shield-24.png'

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-gray-800/60 bg-gray-900/30 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-400 via-purple-400 to-indigo-400 bg-clip-text text-transparent">VispTech</h3>
            <p className="text-gray-300 mt-3 leading-relaxed">
              Building intelligent, high-performance digital products that drive real business results.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-200 tracking-wider">Navigation</h4>
            <ul className="mt-4 space-y-3 text-gray-300">
              <li><a href="/#home" className="hover:text-white transition-colors">Home</a></li>
              <li><a href="/#services" className="hover:text-white transition-colors">Services</a></li>
              <li><a href="/#portfolio" className="hover:text-white transition-colors">Portfolio</a></li>
              <li><a href="/#about" className="hover:text-white transition-colors">About</a></li>
              <li><a href="/#testimonials" className="hover:text-white transition-colors">Testimonials</a></li>
              <li><a href="/#process" className="hover:text-white transition-colors">Process</a></li>
              <li><a href="/#contact-info" className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-200 tracking-wider">Connect</h4>
            <div className="mt-4">
              <a href="tel:+917496070129" className="text-2xl font-semibold text-white hover:text-indigo-300 transition-colors">
                +91 74960 70129
              </a>
              <p className="mt-2 text-xs uppercase tracking-[0.3em] text-indigo-300">Call us directly</p>
            </div>
            <div className="footer-social-icons">
              <a href="https://www.linkedin.com/company/vaisptech/" target="_blank" aria-label="LinkedIn" rel="noreferrer">
                <i className="fab fa-linkedin" />
              </a>
              {/* <a href="#" target="_blank" aria-label="instagram" rel="noreferrer">
                <i className="fab fa-instagram" />
              </a> */}
              <a href="https://www.facebook.com/profile.php?id=61582863110270" target="_blank" aria-label="facebook" rel="noreferrer">
                <i className="fab fa-facebook" />
              </a>
              <a href="https://x.com/vaisptech" target="_blank" aria-label="X (formerly Twitter)" rel="noreferrer">
                <i className="fab fa-x-twitter" />
              </a>
            </div>
            <div className="mt-6 flex items-center gap-4 text-gray-300">
              <a href="/#contact-info" aria-label="Contact" className="hover:text-white transition-colors">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                </svg>
              </a>
              <a href="/#services" aria-label="Services" className="hover:text-white transition-colors">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="3" />
                  <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 008 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 003.6 15a1.65 1.65 0 00-1.51-1H2a2 2 0 010-4h.09A1.65 1.65 0 003.6 8a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 008 3.6a1.65 1.65 0 001-1.51V2a2 2 0 014 0v.09c0 .65.38 1.24 1 1.51a1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06c-.38.38-.5.94-.33 1.82.27.62.86 1 1.51 1H22a2 2 0 010 4h-.09c-.65 0-1.24.38-1.51 1z" />
                </svg>
              </a>
              <a href="/" aria-label="Home" className="hover:text-white transition-colors">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-800/60 flex items-center justify-between text-sm text-gray-400">
          <div>
            <p>© {year} VaispTech. All rights reserved.</p>
          </div>
          <a href="/admin" aria-label="Admin Login" title="Admin Login" className="inline-flex items-center justify-center text-gray-300 hover:text-white transition-colors bg-transparent border border-gray-700/60 hover:border-gray-500 rounded-lg p-2">
            <img src={adminlogo} alt="Admin Logo" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
